export default __webpack_public_path__ + "static/wifi_pineapple-55ae30b46a82ba38fb6a9bc6c359a6ca.png";